import { render } from "./ReportThemeChartEditor.vue?vue&type=template&id=b54f99d6&scoped=true"
import script from "./ReportThemeChartEditor.vue?vue&type=script&lang=js"
export * from "./ReportThemeChartEditor.vue?vue&type=script&lang=js"

import "./ReportThemeChartEditor.vue?vue&type=style&index=0&id=b54f99d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b54f99d6"]])

export default __exports__